<template>
  <div class="affiliate-admin">
    <div class="header">
      <div>
        <h2>Affiliate Program</h2>
        <div class="subtitle">
          Invite-only LearningFirst partner program: intake, partner review, commission policies, ledger, and payouts.
          Commission amounts are in USD; payouts are in the settlement currency.
        </div>
      </div>
    </div>

    <el-tabs v-model="activeTab" class="affiliate-tabs">
      <el-tab-pane label="Program" name="program" lazy>
        <program-tab />
      </el-tab-pane>
      <el-tab-pane label="Invitations" name="invitations" lazy>
        <invitations-tab />
      </el-tab-pane>
      <el-tab-pane label="Partners" name="partners" lazy>
        <partners-tab @open-ledger="openForAffiliate('ledger', $event)" @open-payouts="openForAffiliate('payouts', $event)" />
      </el-tab-pane>
      <el-tab-pane label="Policies" name="policies" lazy>
        <policies-tab />
      </el-tab-pane>
      <el-tab-pane label="Ledger & Exceptions" name="ledger" lazy>
        <ledger-tab :affiliate-id="affiliateId" @affiliate-change="rememberAffiliate" />
      </el-tab-pane>
      <el-tab-pane label="Payouts" name="payouts" lazy>
        <payouts-tab :affiliate-id="affiliateId" @affiliate-change="rememberAffiliate" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ProgramTab from './ProgramTab.vue'
import InvitationsTab from './InvitationsTab.vue'
import PartnersTab from './PartnersTab.vue'
import PoliciesTab from './PoliciesTab.vue'
import LedgerTab from './LedgerTab.vue'
import PayoutsTab from './PayoutsTab.vue'
import { OBJECT_ID_PATTERN } from './affiliateMixin'

const TABS = ['program', 'invitations', 'partners', 'policies', 'ledger', 'payouts']

export default {
  name: 'LFAdminAffiliateProgram',
  components: {
    ProgramTab,
    InvitationsTab,
    PartnersTab,
    PoliciesTab,
    LedgerTab,
    PayoutsTab
  },
  computed: {
    activeTab: {
      get() {
        const tab = this.$route.query.tab
        return TABS.includes(tab) ? tab : 'program'
      },
      set(tab) {
        this.updateQuery({ tab })
      }
    },
    affiliateId() {
      const id = this.$route.query.affiliate
      return typeof id === 'string' && OBJECT_ID_PATTERN.test(id) ? id : ''
    }
  },
  methods: {
    updateQuery(changes) {
      const query = { ...this.$route.query, ...changes }
      Object.keys(query).forEach((key) => {
        if (query[key] === '' || query[key] === null || query[key] === undefined) delete query[key]
      })
      this.$router.replace({ query }).catch(() => {})
    },
    openForAffiliate(tab, affiliateId) {
      this.updateQuery({ tab, affiliate: affiliateId })
    },
    rememberAffiliate(affiliateId) {
      if (affiliateId !== this.affiliateId) this.updateQuery({ affiliate: affiliateId })
    }
  }
}
</script>

<style scoped>
.affiliate-admin {
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.header h2 {
  margin: 0;
  color: #303133;
  font-size: 22px;
  line-height: 1.25;
}

.subtitle {
  margin-top: 4px;
  color: #909399;
  font-size: 13px;
}
</style>

<style>
.el-message-box.affiliate-wide-message-box {
  width: 600px;
  max-width: 92vw;
}
</style>
